import { render, staticRenderFns } from "./MenuClonadoParaUsuario.vue?vue&type=template&id=4bbf882a&"
import script from "./MenuClonadoParaUsuario.vue?vue&type=script&lang=js&"
export * from "./MenuClonadoParaUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports